import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { contactItem as getContactItem } from '../utils/urls';

import { Contact } from 'types/contacts';
import { ErrorModal } from 'types/modalTypes';

async function fetchContact({ id, account }: TVariables): Promise<TResult> {
  const response = await fetch(getContactItem(account, id), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Contact | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  account: number;
  id: number;
};

function useGetContactInfo({
  account,
  id,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_contact_info', account, id],
    async () => {
      if (id)
        return await fetchContact({
          id,
          account,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetContactInfo };
